module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('goodsGridEditor', {
    attrs: {
      "res": _vm.t_data,
      "show_price": false,
      "show_subtitle": false,
      "show_brand": false,
      "show_space": false,
      "show_style": false,
      "limit_num": _vm.limit_num
    },
    on: {
      "bindGoods": _vm.showGoods
    }
  }), _vm._v(" "), _c('goodsPicker', {
    attrs: {
      "usage": "pc",
      "visible": _vm.goodsVisible
    },
    on: {
      "pickGoods": _vm.pickGoods,
      "closeDialog": _vm.closeDialog
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4303c6a4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4303c6a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pc/homePage/components/plugins/goodsGrid/style.vue
// module id = 2672
// module chunks = 0